import { ButtonNew, IconButton, LoadingWrapper, MainLayoutContainer } from '@lune-fe/lune-ui-lib'
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined'
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined'
import { Box } from '@mui/material'
import Stack from '@mui/material/Stack'
import { FC, ReactNode } from 'react'

import BackButtonWithFromState from 'views/CalculateEmissions/Shared/BackButtonWithFromState'

const SharedLayout: FC<{
    loading: boolean
    stepsComponent: ReactNode
    children: ReactNode
    handleNext?: () => void
    handlePrev?: () => void
    handleBack?: () => void
    prevButtonLabel?: string
    nextButtonLabel?: string
}> = ({
    loading,
    handleNext,
    handlePrev,
    handleBack,
    stepsComponent,
    children,
    prevButtonLabel,
    nextButtonLabel,
}) => {
    return (
        <LoadingWrapper loading={loading} sx={{ minHeight: '100vh' }}>
            {!loading && (
                <MainLayoutContainer
                    headerComponent={
                        <Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    mb: 6,
                                }}
                            >
                                {handleBack ? (
                                    <IconButton
                                        style="floating"
                                        leadingIcon={<ArrowBackOutlinedIcon />}
                                        sx={{ ml: -1.5 }}
                                        onClick={handleBack}
                                    />
                                ) : (
                                    <BackButtonWithFromState />
                                )}
                            </Box>
                            {stepsComponent}
                        </Box>
                    }
                >
                    <Stack
                        direction="column"
                        sx={{
                            mb: 9,
                            width: '100%',
                        }}
                        spacing={{
                            xs: 9,
                        }}
                    >
                        {children}
                    </Stack>
                    <Box sx={{ mt: 4, display: 'flex', justifyContent: 'space-between' }}>
                        {handlePrev ? (
                            <ButtonNew
                                leadingIcon={<ArrowBackOutlinedIcon />}
                                style={'outline'}
                                onClick={() => handlePrev()}
                            >
                                {prevButtonLabel ? `Previous: ${prevButtonLabel}` : 'Previous'}
                            </ButtonNew>
                        ) : (
                            <Box />
                        )}
                        {handleNext && (
                            <ButtonNew
                                leadingIcon={<ArrowForwardOutlinedIcon />}
                                onClick={handleNext}
                            >
                                {nextButtonLabel ? `Next: ${nextButtonLabel}` : 'Next'}
                            </ButtonNew>
                        )}
                    </Box>
                </MainLayoutContainer>
            )}
        </LoadingWrapper>
    )
}

export default SharedLayout
